/**
 * Tooltipen i graferna under Flaggor > Utförare: översikten, Flaggöversikt och Flagghistorik.
 *
 * Samma stil som flaggvyernas övriga tooltips (#40, flagTooltip.css): opak svart bakgrund, 2 px
 * hörn, 8 px luft upptill och nedtill och 12 px på sidorna, ingen pil. Typsnittet är detsamma som på
 * grafernas axlar. Inställningarna ligger här så att vyerna inte glider isär igen.
 */

const TYPSNITT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif"

/**
 * @param färgruta Färgrutan framför varje rad hör ihop med en förklaring. Grafer utan förklaring,
 * som översiktens staplar, får ingen ruta – den pekar inte på något.
 */
export const grafTooltip = (färgruta: boolean) => ({
  backgroundColor: '#000',
  titleColor: '#fff',
  bodyColor: '#fff',
  titleFont: { family: TYPSNITT, size: 14, weight: 'bold' as const },
  bodyFont: { family: TYPSNITT, size: 14, weight: 'normal' as const },
  cornerRadius: 2,
  // Två pixlar mer upptill än nedtill. Med lika mycket såg texten ut att sitta för högt.
  padding: { top: 10, bottom: 8, left: 12, right: 12 },
  // Ingen pil. Tooltipen står i stället lite ifrån det man pekar på.
  caretSize: 0,
  caretPadding: 7,
  displayColors: färgruta,
  // Luft mellan färgrutan och texten.
  boxPadding: 6,
})

/**
 * Färgrutan som i förklaringarna: datasetets ljusa fyllning med mörk kant på 1,5 px. Chart.js tar
 * annars elementets egna färger, och för en linje är det punkternas helt mörka fyllning.
 */
export const förklaringsfärg = (item: any) => ({
  borderColor: item.dataset.borderColor,
  backgroundColor: item.dataset.backgroundColor,
  borderWidth: 1.5,
})

/**
 * Hur många pixlar färgrutan lyfts, se färgrutaIHöjdMedTexten.
 */
const RUTANS_LYFT = 1

/**
 * Plugin som lyfter färgrutan i tooltipen, så att den står mitt för texten bredvid.
 *
 * Chart.js centrerar rutan och texten på samma höjd, men texten placeras efter typsnittets hela
 * teckenruta, som också rymmer plats för svansar under raden. Versaler och siffror hamnar därför
 * lite högre än rutans mitt, och raden ser sned ut. Det finns ingen inställning för det.
 *
 * `_drawColorBox` är en intern metod i Chart.js. Finns den inte längre efter en uppgradering gör
 * plugin:et ingenting, och rutan står där Chart.js sätter den.
 *
 * Läggs på graferna med färgruta: `<Bar plugins={[färgrutaIHöjdMedTexten]} … />`.
 */
export const färgrutaIHöjdMedTexten = {
  id: 'fargrutaIHojdMedTexten',
  afterInit: (chart: any) => {
    const tooltip = chart.tooltip
    if (typeof tooltip?._drawColorBox !== 'function') return
    const rita = tooltip._drawColorBox.bind(tooltip)
    tooltip._drawColorBox = (ctx: any, pt: any, ...övrigt: any[]) => rita(ctx, { ...pt, y: pt.y - RUTANS_LYFT }, ...övrigt)
  },
}

/** Flaggor per brukare: alltid tre decimaler, med svensk decimalkomma. */
export const perBrukare = (värde: number) => Number(värde).toLocaleString('sv-SE', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
